import { Component, computed, inject, signal } from '@angular/core';



import { UserStore } from '../header/models/internal/user.store';
import { ModalPlanoOtimizaComponent } from '../../../modules/home-v2/components/modal-plano-otimiza/modal-plano-otimiza.component';
import { UserService } from '../../services/common/user.service';


@Component({
  selector: 'app-freemium-acabando',
  standalone: true,
  imports: [ModalPlanoOtimizaComponent],
  templateUrl: './freemium-acabando.component.html',
  styleUrl: './freemium-acabando.component.scss'
})
export class FreemiumAcabandoComponent {
  private readonly userStore = inject(UserStore);
  private userService = inject(UserService)

  public readonly showOtimizaModal = signal(false);

  private readonly isFreemium = computed(() => this.userStore.user().plan === 'Freemium');

  public readonly showBlockingModal = computed(
    () => this.isFreemium()
  );

  public openOtimiza(): void {
    this.showOtimizaModal.set(true);
  }

  public closeOtimiza(): void {
    this.showOtimizaModal.set(false);
  }

  public logout() {
    this.userService.logout();
  }
}
